// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"fe5cf03b","513":"36f1fab1","703":"2e56fae0"}[chunkId] + ".chunk.js";
};